// 数据字典 或者 附件配置 数据
import $http from '@/utils/httpRequest'
let stateData = {
    extractNumberType:[],// 抽取条件类型 （数据字典）

    mainTypeList:[], // 企业主体类型
    publicScopeList:[], // 公开范围
    illegalTypeList:[], // 违法违规类型
    evalBusinessTypeList:[], // 评价业务类型
    evalDefaultValueTypeList:[], // 评价默认值字典
    punishTypeList:[],// 主体处罚类型 （数据字典）
    punishLimitList:[],// 主体处罚限制行为类型 （数据字典）
    pushWebsiteList:[],// 主体奖惩推送网站类型 （数据字典）
    rewardAttList:[],// 主体奖励附件
    punishAttList:[],// 主体惩罚附件
    mainRevokeAttList:[], // 主体奖惩撤回附件
    mainArchivesAttList:[],// 主体信用评价档案附件
    checkResultAttConfig:[],//
    noticeAttConfig:[],//公告
    personRegisterAttConfig: [],
    complaintReportingAttConfig: [],
    openEvalSuperviseAtt:[],// 线下新增开评标监管附件
    entPrizeAtt:[],
    complaintMatterAtt:[],//投诉
    receiveSuggesstionAtt:[],//投诉第二步
    // 信用报告附件
    personBaseAttConfig:[],//自然人基本信息附件配置，[person_base_info_att]
    entBaseAttConfig:[],//主体基本信息附件[ent_base_info_att]
    entBankInfoAtt:[],///法人其他银行账户信息附件[ent_bank_info_att]
    entCreditEvaluationAtt:[],//主体其他信息-信用评价附件[ent_credit_evaluation_att]
    entEmpCertAtt:[],//主体人员信息-人员资格信息附件[ent_emp_cert_att]
    entEmpInfoAtt:[],//主体人员信息-人员基本信息附件[ent_emp_info_att]
    entEmpRewardPunishmentAtt:[],//主体人员信息-人员奖惩信息附件[ent_emp_reward_punishment_att]
    entInfoDisclosureAtt:[],//主体其他信息-信息披露附件[ent_info_disclosure_att]
    entLitigationAndArbitrationAtt:[],//主体其他信息-诉讼及仲裁情况附件[ent_litigation_and_arbitration_att]
    entOtherMaterialAtt:[],//主体其他信息-其他投标证明材料附件[ent_other_material_att]
    entPerformanceAtt:[],//主体业绩信息附件[ent_performance_att]
    entPrizeAttInfo:[],//主体奖惩信息-奖励信息附件[ent_prize_att]
    entQualificationCertAtt:[],//主体证书/资质信息附件[ent_qualification_cert_att]
    entServiceItemsAtt:[],//中介服务事项附件[ent_service_items_att]
    entSocialSecurityAtt:[],//主体财税/社保信息-企业社保信息附件[ent_social_security_att]
    entTaxAtt:[],//主体财税/社保信息-企业财税信息附件[ent_tax_att]

    portalCreditSystemAtt:[],//信用制度
    portalAdministrativePenaltiesAtt:[],// 行政处罚附件
    lawsRegulationsAtt:[],// 政策法规附件
    infomationPublishAtt:[],// 信息发布附件
    publishColumnOption:[],// 信息发布-发布栏目字典
    applicationDocumentLevel: [],//文件层级
    applicationDocumentValidity: [],//文件有效性
    applicationDocumentType: [],//文件性质
    tradingCenterOption:[],// 交易中心 下拉选项数据 可删除
    uerTreeOption:[],// 登录用户的所有权限树值
    uerdefultOptionCode:[],// 默认选中的数据源codes
    defultItemArr:[],//默认选中的数据item
    regionTreeList:[],
}

//交易中心
const getDataOfTrading=function(categoryCode,callback){
    $http.post('/sysGuardConfig/supervisionOrgPage',{
          "page": 1,
          "rows": 10,
          "searchKey": "",
        }).then((data)=>{
          var tradeOrgIdOptions=data.data.rows;
          if(callback)callback(tradeOrgIdOptions)
        })
}
const getAttByCode = function(categoryCode,callback){
    $http.get(`/attachment/getAttDatas?categoryCode=${categoryCode}`).then((res) => {
        if (res.data.code == 1 && res.data.data.length > 0) {
            res.data.data.forEach((item,index)=>{
                var remark = item.remark?JSON.parse(item.remark):{};
                item.required = remark.required || false;
                item.allows= remark.allows || '*';
                item.templateSrc= remark.templateSrc || '';
                item.describeInfo= remark.describeInfo || '';
                item.fileTypeName = item.name;
                item.filePath = "";
                item.name = "";
                // delete item.id;
            })
            if(callback)callback(res.data.data)
        }
    })
}
const getDicByCode = function(categoryCode,callback){
    $http.get('/sys/dictData/getList?type=' + categoryCode).then((res)=>{
        if (res.data.code == 1 && res.data.data.length > 0) {
            if(callback)callback(res.data.data || [])
        }


    })
}
const getDataByCode = function(categoryCode,callback){
    $http.get('/entityInfo/getAttachmentCategoryInfo').then((res)=>{
        if (res.data.code == 1 && res.data.data.length > 0) {
            if(callback)callback(res.data.data[categoryCode] || [])
        }
    })
}
const  findfunc=function(arr,defultCodeArr=[],defultItemArr){
    arr.forEach((item,index)=>{
        // 过滤出默认选中的节点 并且是最后一级
        if( item.configType==1&&item.type!=="region"){
            defultCodeArr.push(item.code)
            defultItemArr.push(item)
        }
        if(item.children&&item.children.length>0){
            findfunc(item.children,defultCodeArr,defultItemArr)
        }
    })
   return  {defultCodeArr,defultItemArr};
}
// 获取当前用户权限内数据源配置
const getUserTreeOption=function(categoryCode,callback){
         ////config/sysDeptDataPermisionConfig/userDeptTree
         $http.get('/config/sysDeptDataPermisionConfig/userDeptTree').then((res)=>{
            if(res.data.code==1&&res.data.data){
                var dataInfo=res.data.data||[]
            //   this.$emit('update:modelValue',[['330101','JG71668'],['330101','JG25250']])
                var defultCodeArr=[]
                var defultItemArr=[]
                var arrlist= findfunc(dataInfo,defultCodeArr,defultItemArr)
                // console.log(dataInfo,arrlist,"arrlist")
              if(callback)callback(res.data.data,arrlist)
              }else{
                this.$message.error(res.data.msg)
              }
            }).catch((err)=>{
                console.log(err);
            })
        
   
}

export default {

        namespaced: true,
        state:stateData,
        mutations:{
            setUserOption(state,data){
                state.uerTreeOption = data;
            },
            setUserdefultOption(state,data){
                state.uerdefultOptionCode = data;
            },
            setUserdefultdefultItem(state,data){
                state.defultItemArr = data;
            },
            setExtractNumberType(state,data){
                state.extractNumberType = data;
            },
            setMainTypeList(state,data){
                state.mainTypeList = data;
            },
            setPublicScopeList(state,data){
                state.publicScopeList = data;
            },
            setIllegalTypeList(state,data){
                state.illegalTypeList = data;
            },
            setEvalBusinessTypeList(state,data){
                state.evalBusinessTypeList = data;
            },
            setEvalDefaultValueTypeList(state,data){
                state.evalDefaultValueTypeList = data;
            },
            setPunishTypeList(state,data){
                state.punishTypeList = data;
            },
            setPunishLimitList(state,data){
                state.punishLimitList = data;
            },
            setPushWebsiteList(state,data){
                state.pushWebsiteList = data;
            },
            setRewardAttList(state,data){
                state.rewardAttList = data;
            },
            setMainRevokeAttList(state,data){
                state.mainRevokeAttList = data;
            },
            setMainArchivesAttList(state,data){
                state.mainArchivesAttList=data
            },
            setPunishAttList(state,data){
                state.punishAttList = data;
            },
            setNoticeAttConfig(state,data){
                state.noticeAttConfig = data;
            },
            setOpenEvalSuperviseAtt(state,data){
                state.openEvalSuperviseAtt = data;
            },
            setCheckResultAttConfig(state,data){
                state.checkResultAttConfig = data;
            },
            setPersonRegisterAttConfig(state,data){
                state.personRegisterAttConfig = data;
            },
            setComplaintReportingAttConfig(state,data){
                state.complaintReportingAttConfig = data;
            },
            setEntPrizeAtt(state,data){
                state.entPrizeAtt = data;
            },
            setComplaintMatterAtt(state,data){
                state.complaintMatterAtt = data;
            },
            setReceiveSuggesstionAtt(state,data){
                state.receiveSuggesstionAtt = data;
            },
            setApplicationDocumentLevel(state,data) {
                state.applicationDocumentLevel = data;
            },
            setPublishColumnOption(state,data) {
                state.publishColumnOption = data;
            },

            setApplicationDocumentValidity(state,data) {
                state.applicationDocumentValidity = data;
            },
            setApplicationDocumentType(state,data) {
                state.applicationDocumentType = data;
            },
            // 信用报告
            setPersonBaseAttConfig(state,data){
                state.personBaseAttConfig = data;
            },
            setEntBaseAttConfig(state,data){
                state.entBaseAttConfig = data;
            },
            setEntBankInfoAtt(state,data){
                state.entBankInfoAtt = data;
            },
            setEntCreditEvaluationAtt(state,data){
                state.entCreditEvaluationAtt = data;
            },
            setEntEmpCertAtt(state,data){
                state.entEmpCertAtt = data;
            },
            setEntEmpInfoAtt(state,data){
                state.entEmpInfoAtt = data;
            },
            setEntEmpRewardPunishmentAtt(state,data){
                state.entEmpRewardPunishmentAtt = data;
            },
            setEntInfoDisclosureAtt(state,data){
                state.entInfoDisclosureAtt = data;
            },
            setEntLitigationAndArbitrationAtt(state,data){
                state.entLitigationAndArbitrationAtt = data;
            },
            setEntOtherMaterialAtt(state,data){
                state.entOtherMaterialAtt = data;
            },
            setEntPerformanceAtt(state,data){
                state.entPerformanceAtt = data;
            },
            setentPrizeAttInfo(state,data){
                state.entPrizeAttInfo = data;
            },
            setEntQualificationCertAtt(state,data){
                state.entQualificationCertAtt = data;
            },
            setEntServiceItemsAtt(state,data){
                state.entServiceItemsAtt = data;
            },
            setEntSocialSecurityAtt(state,data){
                state.entSocialSecurityAtt = data;
            },
            setEntTaxAtt(state,data){
                state.entTaxAtt = data;
            },

            setPortalCreditSystemAtt(state,data){
                state.portalCreditSystemAtt = data;
            },
            setPortalAdministrativePenaltiesAtt(state,data){
                state.portalAdministrativePenaltiesAtt = data;
            },
            setLawsRegulationsAtt(state,data){
                state.lawsRegulationsAtt = data;
            },
            setInfomationPublishAtt(state,data){
                state.infomationPublishAtt = data;
            },
            // 交易中心
            setTradingCenterOption(state,data){
                state.tradingCenterOption = data;
            },
            setRegionTree(state,data){
                state.regionTreeList = data;
            },
        },
        actions:{
            // 获取当前用户数据源值
            getUserOptionData({commit}){ 
                if(stateData.uerTreeOption.length == 0){
                    getUserTreeOption(1,function(data,defultObj){
                        commit('setUserOption',data)
                        commit('setUserdefultOption',defultObj.defultCodeArr)
                        commit('setUserdefultdefultItem',defultObj.defultItemArr)
                    })
                }else{
                    commit('setUserOption',stateData.uerTreeOption)
                    commit('setUserdefultOption',stateData.uerdefultOptionCode)
                    commit('setUserdefultdefultItem',stateData.defultItemArr)
                }
            }, 
            getExtractNumberType({commit}){ //获取法人机构类别
                if(stateData.extractNumberType.length == 0){
                    getDicByCode('extract_number_type',function(data){
                        commit('setExtractNumberType',data)
                    })
                }else{
                    commit('setExtractNumberType',stateData.extractNumberType)
                }
            },
            getMainTypeList({commit}){ //主体类型 （数据字典）
                if(stateData.mainTypeList.length == 0){
                    getDicByCode('94',function(data){
                        commit('setMainTypeList',data)
                    })
                }else{
                    commit('setMainTypeList',stateData.mainTypeList)
                }
            },
            getPublicScopeList({commit}){ //主体奖惩公开范围 （数据字典）
                if(stateData.publicScopeList.length == 0){
                    getDicByCode('10063',function(data){
                        commit('setPublicScopeList',data)
                    })
                }else{
                    commit('setPublicScopeList',stateData.publicScopeList)
                }
            },
            getIllegalTypeList({commit}){ //主体违法违规类型 （数据字典）
                if(stateData.illegalTypeList.length == 0){
                    getDicByCode('10018',function(data){
                        commit('setIllegalTypeList',data)
                    })
                }else{
                    commit('setIllegalTypeList',stateData.illegalTypeList)
                }
            },
            getEvalBusinessTypeList({commit}){ // 评价业务类型
                if(stateData.evalBusinessTypeList.length == 0){
                    getDicByCode('pingjiachufajiedian',function(data){
                        commit('setEvalBusinessTypeList',data)
                    })
                }else{
                    commit('setEvalBusinessTypeList',stateData.evalBusinessTypeList)
                }
            },
            getEvalDefaultValueTypeList({commit,state}){ // 评价默认值类型
                if(stateData.evalDefaultValueTypeList.length == 0){
                    getDicByCode('pingjiamorenzhi',function(data){
                        commit('setEvalDefaultValueTypeList',data)
                    })
                }else{
                    commit('setEvalDefaultValueTypeList',state.evalDefaultValueTypeList)
                }
            },
            getPunishTypeList({commit}){ //主体处罚类型 （数据字典）
                if(stateData.punishTypeList.length == 0){
                    getDicByCode('96',function(data){
                        commit('setPunishTypeList',data)
                    })
                }else{
                    commit('setPunishTypeList',stateData.punishTypeList)
                }
            },
            getPunishLimitList({commit}){ //主体处罚限制行为类型 （数据字典）
                if(stateData.punishLimitList.length == 0){
                    getDicByCode('10021',function(data){
                        commit('setPunishLimitList',data)
                    })
                }else{
                    commit('setPunishLimitList',stateData.punishLimitList)
                }
            },
            getPushWebsiteList({commit}){ //主体奖惩推送网站类型 （数据字典）
                if(stateData.pushWebsiteList.length == 0){
                    getDicByCode('jg_subject_push_website',function(data){

                        commit('setPushWebsiteList',data)
                    })
                }else{
                    commit('setPushWebsiteList',stateData.pushWebsiteList)
                }
            },
            getRewardAttList({commit}){ // 获取主体奖励附件配置
                if(stateData.rewardAttList.length == 0){
                    getAttByCode('jg_subject_reward_att',function(data){
                        commit('setRewardAttList',data)
                    })
                }else{
                    commit('setRewardAttList',stateData.rewardAttList)
                }
            },
            getPunishAttList({commit}){ // 获取主体惩罚附件配置
                if(stateData.punishAttList.length == 0){
                    getAttByCode('jg_subject_limit_illegal_att',function(data){
                        commit('setPunishAttList',data)
                    })
                }else{
                    commit('setPunishAttList',stateData.punishAttList)
                }
            },
            getMainRevokeAttList({commit}){ // 获取主体奖惩撤回附件配置
                if(stateData.mainRevokeAttList.length == 0){
                    getAttByCode('jg_subject_illegal_revoke_att',function(data){
                        commit('setMainRevokeAttList',data)
                    })
                }else{
                    commit('setMainRevokeAttList',stateData.mainRevokeAttList)
                }
            },
            //mainArchivesAttList
            getMainArchivesAttList({commit}){ // 获取主体信用评价档案附件配置
                if(stateData.mainArchivesAttList.length == 0){
                    getAttByCode('subject_evaluate_archive',function(data){
                        commit('setMainArchivesAttList',data)
                    })
                }else{
                    commit('setMainArchivesAttList',stateData.mainArchivesAttList)
                }
            },
            getCheckResultAttConfig({commit}){
                if(stateData.checkResultAttConfig.length == 0){
                    getAttByCode('check_result_att',function(data){
                        commit('setCheckResultAttConfig',data)
                    })
                }else{
                    commit('setCheckResultAttConfig',stateData.checkResultAttConfig)
                }

            },
            getPersonRegisterAttConfig({commit}){
                if(stateData.personRegisterAttConfig.length == 0){
                    getAttByCode('person_register_att',function(data){
                        commit('setPersonRegisterAttConfig',data)
                    })
                }else{
                    commit('setPersonRegisterAttConfig',stateData.personRegisterAttConfig)
                }

            },
            getComplaintReportingAttConfig({commit}){
                if(stateData.complaintReportingAttConfig.length == 0){
                    getAttByCode('complaint_reporting_att',function(data){
                        commit('setComplaintReportingAttConfig',data)
                    })
                }else{
                    commit('setComplaintReportingAttConfig',stateData.complaintReportingAttConfig)
                }

            },
            getNoticeAttConfig({commit}){
                if(stateData.noticeAttConfig.length == 0){
                    getAttByCode('check_result_notice_att',function(data){
                        commit('setNoticeAttConfig',data)
                    })
                }else{
                    commit('setNoticeAttConfig',stateData.noticeAttConfig)
                }
            },
            getOpenEvalSuperviseAtt({commit}){
                if(stateData.openEvalSuperviseAtt.length == 0){
                    getAttByCode('open_eval_supervise_att',function(data){
                        commit('setOpenEvalSuperviseAtt',data)
                    })
                }else{
                    commit('setOpenEvalSuperviseAtt',stateData.openEvalSuperviseAtt)
                }
            },
            getComplaintMatterAtt({commit}){
                if(stateData.complaintMatterAtt.length == 0){
                    getAttByCode('complaint_matter_att',function(data){
                        commit('setComplaintMatterAtt',data)
                    })
                }else{
                    commit('setComplaintMatterAtt',stateData.complaintMatterAtt)
                }
            },
            getReceiveSuggesstionAtt({commit}){
                if(stateData.receiveSuggesstionAtt.length == 0){
                    getAttByCode('receive_suggesstion_att',function(data){
                        commit('setReceiveSuggesstionAtt',data)
                    })
                }else{
                    commit('setReceiveSuggesstionAtt',stateData.receiveSuggesstionAtt)
                }
            },
            // 信用报告
            getPersonBaseAttConfig({commit}){
                if(stateData.personBaseAttConfig.length == 0){
                    getDataByCode('person_base_info_att',function(data){
                        commit('setPersonBaseAttConfig',data)
                    })
                }else{
                    commit('setPersonBaseAttConfig',stateData.personBaseAttConfig)
                }

            },
            getEntBaseAttConfig({commit}){
                if(stateData.entBaseAttConfig.length == 0){
                    getDataByCode('ent_base_info_att',function(data){
                        commit('setEntBaseAttConfig',data)
                    })
                }else{
                    commit('setEntBaseAttConfig',stateData.entBaseAttConfig)
                }
            },
            getEntBankInfoAtt({commit}){

                if(stateData.entBankInfoAtt.length == 0){
                    getDataByCode('ent_bank_info_att',function(data){
                        commit('setEntBankInfoAtt',data)
                    })
                }else{
                    commit('setEntBankInfoAtt',stateData.entBankInfoAtt)
                }

            },
            getEntCreditEvaluationAtt({commit}){
                if(stateData.entCreditEvaluationAtt.length == 0){
                    getDataByCode('ent_credit_evaluation_att',function(data){
                        commit('setEntCreditEvaluationAtt',data)
                    })
                }else{
                    commit('setEntCreditEvaluationAtt',stateData.entCreditEvaluationAtt)
                }

            },
            getEntEmpCertAtt({commit}){
                if(stateData.entEmpCertAtt.length == 0){
                    getDataByCode('ent_emp_cert_att',function(data){
                        commit('setEntEmpCertAtt',data)
                    })
                }else{
                    commit('setEntEmpCertAtt',stateData.entEmpCertAtt)
                }

            },
            getEntEmpInfoAtt({commit}){
                if(stateData.entEmpInfoAtt.length == 0){
                    getDataByCode('ent_emp_info_att',function(data){
                        commit('setEntEmpInfoAtt',data)
                    })
                }else{
                    commit('setEntEmpInfoAtt',stateData.entEmpInfoAtt)
                }

            },
            getEntEmpRewardPunishmentAtt({commit}){
                if(stateData.entEmpRewardPunishmentAtt.length == 0){
                    getDataByCode('ent_emp_reward_punishment_att',function(data){
                        commit('setEntEmpRewardPunishmentAtt',data)
                    })
                }else{
                    commit('setEntEmpRewardPunishmentAtt',stateData.entEmpRewardPunishmentAtt)
                }

            },
            getEntInfoDisclosureAtt({commit}){
                if(stateData.entInfoDisclosureAtt.length == 0){
                    getDataByCode('ent_info_disclosure_att',function(data){
                        commit('setEntInfoDisclosureAtt',data)
                    })
                }else{
                    commit('setEntInfoDisclosureAtt',stateData.entInfoDisclosureAtt)
                }

            },
            getEntLitigationAndArbitrationAtt({commit}){
                if(stateData.entLitigationAndArbitrationAtt.length == 0){
                    getDataByCode('ent_litigation_and_arbitration_att',function(data){
                        commit('setEntLitigationAndArbitrationAtt',data)
                    })
                }else{
                    commit('setEntLitigationAndArbitrationAtt',stateData.entLitigationAndArbitrationAtt)
                }

            },
            getEntOtherMaterialAtt({commit}){
                if(stateData.entOtherMaterialAtt.length == 0){
                    getDataByCode('ent_other_material_att',function(data){
                        commit('setEntOtherMaterialAtt',data)
                    })
                }else{
                    commit('setEntOtherMaterialAtt',stateData.entOtherMaterialAtt)
                }

            },
            getEntPerformanceAtt({commit}){
                if(stateData.entPerformanceAtt.length == 0){
                    getDataByCode('ent_performance_att',function(data){
                        commit('setEntPerformanceAtt',data)
                    })
                }else{
                    commit('setEntPerformanceAtt',stateData.entPerformanceAtt)
                }

            },
            getEntPrizeAttInfo({commit}){
                if(stateData.entPrizeAttInfo.length == 0){
                    getDataByCode('ent_prize_att',function(data){
                        commit('setEntPrizeAttInfo',data)
                    })
                }else{
                    commit('setEntPrizeAttInfo',stateData.entPrizeAttInfo)
                }

            },
            getEntQualificationCertAtt({commit}){
                if(stateData.entQualificationCertAtt.length == 0){
                    getDataByCode('ent_qualification_cert_att',function(data){
                        commit('setEntQualificationCertAtt',data)
                    })
                }else{
                    commit('setEntQualificationCertAtt',stateData.entQualificationCertAtt)
                }

            },
            getEntServiceItemsAtt({commit}){
                if(stateData.entServiceItemsAtt.length == 0){
                    getDataByCode('ent_service_items_att',function(data){
                        commit('setEntServiceItemsAtt',data)
                    })
                }else{
                    commit('setEntServiceItemsAtt',stateData.entServiceItemsAtt)
                }

            },
            getEntSocialSecurityAtt({commit}){
                if(stateData.entSocialSecurityAtt.length == 0){
                    getDataByCode('ent_social_security_att',function(data){
                        commit('setEntSocialSecurityAtt',data)
                    })
                }else{
                    commit('setEntSocialSecurityAtt',stateData.entSocialSecurityAtt)
                }

            },
            getEntTaxAtt({commit}){
                if(stateData.entTaxAtt.length == 0){
                    getDataByCode('ent_tax_att',function(data){
                        commit('setEntTaxAtt',data)
                    })
                }else{
                    commit('setEntTaxAtt',stateData.entTaxAtt)
                }

            },
            getApplicationDocumentLevel({commit}) {//获取文件层级
                if(stateData.applicationDocumentLevel.length == 0) {
                    getDicByCode('application_document_level',(data) => {
                        commit('setApplicationDocumentLevel',data)
                    })
                }else {
                    commit('setApplicationDocumentLevel',stateData.applicationDocumentLevel)
                }
            },
            getPublishColumnOption({commit}) {//获取文件层级
                if(stateData.publishColumnOption.length == 0) {
                    getDicByCode('jg_publish_column',(data) => {
                        commit('setPublishColumnOption',data)
                    })
                }else {
                    commit('setPublishColumnOption',stateData.publishColumnOption)
                }
            },
            getApplicationDocumentValidity({commit}) {//获取文件有效性
                if(stateData.applicationDocumentValidity.length == 0) {
                    getDicByCode('application_document_validity',(data) => {
                        commit('setApplicationDocumentValidity',data)
                    })
                }else {
                    commit('setApplicationDocumentValidity',stateData.applicationDocumentValidity)
                }
            },
            getApplicationDocumentType({commit}) {//获取文件性质
                if(stateData.applicationDocumentType.length == 0) {
                    getDicByCode('application_document_type',(data) => {
                        commit('setApplicationDocumentType',data)
                    })
                }else {
                    commit('setApplicationDocumentType',stateData.applicationDocumentType)
                }
            },

            getPortalCreditSystemAtt({commit}){
                if(stateData.portalCreditSystemAtt.length == 0){
                    getAttByCode('portal_credit_system_att',function(data){
                        commit('setPortalCreditSystemAtt',data)
                    })
                }else{
                    commit('setPortalCreditSystemAtt',stateData.portalCreditSystemAtt)
                }
            },
            getPortalAdministrativePenaltiesAtt({commit}){
                if(stateData.portalAdministrativePenaltiesAtt.length == 0){
                    getAttByCode('portal_administrative_penalties_att',function(data){
                        commit('setPortalAdministrativePenaltiesAtt',data)
                    })
                }else{
                    commit('setPortalAdministrativePenaltiesAtt',stateData.portalAdministrativePenaltiesAtt)
                }
            },
            getLawsRegulationsAtt({commit}){
                if(stateData.lawsRegulationsAtt.length == 0){
                    getAttByCode('portal_policies_regulation_att',function(data){
                        commit('setLawsRegulationsAtt',data)
                    })
                }else{
                    commit('setLawsRegulationsAtt',stateData.lawsRegulationsAtt)
                }
            },
            getInfomationPublishAtt({commit}){
                if(stateData.infomationPublishAtt.length == 0){
                    getAttByCode('portal_information_release_att',function(data){
                        commit('setInfomationPublishAtt',data)
                    })
                }else{
                    commit('setInfomationPublishAtt',stateData.infomationPublishAtt)
                }
            },

            // 交易中心
            getTradingCenterOption({commit}){
                if(stateData.tradingCenterOption.length == 0){
                    getDataOfTrading('check_result_notice_att',function(data){
                        commit('setTradingCenterOption',data)
                    })
                }else{
                    commit('setTradingCenterOption',stateData.tradingCenterOption)
                }
            },
            getRegionTree({commit},extendNodeName){
                if(stateData.regionTreeList.length==0){
                    $http.get('/base/region/getRegionTree?parentCode='+siteRegionCode+'&extendNodeName='+extendNodeName,{baseURL:process.env.VUE_APP_proxybaseurl + '/fieldApi'})
                        .then(res=>{
                            commit('setRegionTree',(res.data.data[0] && res.data.data[0].children || []))
                        })
                }else{
                    commit('setRegionTree',stateData.regionTreeList)
                }
            },
        }


}